import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { SiHyperledger } from "react-icons/si";
import "jspdf-autotable";
import DataGridComponent from "../../Components/DataGridComponent";
import { errorAlert } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { MonthlyInteresReportHeader } from "./GridHeaders/MonthlyInteresReportHeader";
import ExcelFormat from "../../Components/ExcelConverter/ExcelFormat";
import { interesColumns, interesMappings } from "../../Components/ExcelConverter/FinancialStatement";
import OneFieldTotal from "../../Components/OneFieldTotal";

export default function MonthlyInteresReport() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'FinanceStatement/MonthlyInterestReport', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const totali = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Total), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: item.Sequence_no,
        muaji: item.Muaji,
        trs: item.Transaksione,
        total: item.Total,
    }));


    useEffect(() => {
        fetchData();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">
            <TitleElements
                icon={SiHyperledger}
                title="Raporti mujor i interesit"
            />
            <ElementsParagraph text="Raporti mujor i interesit është raport sintetik që bën grumbullimin e pagave në secilin muaj të vitit fiskal." />
            <hr></hr>
            <ExcelFormat
                data={data}
                fileName={`Raporti mujor i interesit`}
                columns={interesColumns}
                columnMappings={interesMappings}
                buttonText="XLSX"
            />
            <DataGridComponent columns={MonthlyInteresReportHeader} rows={rows} />
            <OneFieldTotal
                id={1}
                label="Total"
                value={totali}
            />
        </div>
    )
}